import React from 'react';
import { Typography } from '@mui/material';
import Layout from '../components/Layout/Layout';

const Profile: React.FC = () => {
  return (
    <Layout>
      <Typography variant="h4">Profile</Typography>
      {/* TODO: Implement profile view */}
    </Layout>
  );
};

export default Profile;